import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import SuperAdminSidebar from "./SuperAdminSidebar";
import SuperAdminTopNavbar from "./SuperAdminTopNavbar";
import useGeneralStore from "store/general";

// Import super admin pages
import CompanyMaster from "pages/superAdmin/CompanyMaster";
import HsnManagement from "pages/superAdmin/HsnManagement";

export default function SuperAdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { sidebarCollapsed } = useGeneralStore();

  return (
    <>
      <div>
        {/* Sidebar */}
        <SuperAdminSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Main content area */}
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? "lg:pl-16" : "lg:pl-72"
          }`}
        >
          {/* Top Navigation */}
          <SuperAdminTopNavbar setSidebarOpen={setSidebarOpen} />

          {/* Main content */}
          <main className="py-10 min-h-[calc(100vh-4rem)] max-h-[calc(100vh-4rem)] overflow-x-auto overflow-y-auto">
            <Routes>
              <Route path="/companies" element={<CompanyMaster />} />
              <Route path="/hsn" element={<HsnManagement />} />
              <Route
                path="/databases"
                element={
                  <div className="px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">
                      Database Management
                    </h1>
                    <p className="mt-2 text-sm text-gray-700">
                      Coming soon...
                    </p>
                  </div>
                }
              />
              <Route
                path="/settings"
                element={
                  <div className="px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">
                      System Settings
                    </h1>
                    <p className="mt-2 text-sm text-gray-700">
                      Coming soon...
                    </p>
                  </div>
                }
              />
              <Route
                path="/analytics"
                element={
                  <div className="px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">
                      Analytics
                    </h1>
                    <p className="mt-2 text-sm text-gray-700">
                      Coming soon...
                    </p>
                  </div>
                }
              />
            </Routes>
          </main>
        </div>
      </div>
    </>
  );
}

